// pages/invoices/InvoiceListPage.tsx - UPDATED WITH BULK OPERATIONS
import React, { useState, useEffect } from 'react';
import { Container, Typography, Breadcrumbs, Link as MuiLink, Box, Collapse } from '@mui/material';
import { Link } from 'react-router-dom';
import InvoiceList from '../../components/invoices/InvoiceList';
import InvoiceBulkOperations from '../../components/invoices/InvoiceBulkOperations';
import { useAuth } from '../../contexts/AuthContext';

const InvoiceListPage: React.FC = () => {
  const { user } = useAuth();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  // Only show bulk operations to admins
  const isAdmin = user?.role === 'admin' || user?.role === 'gm' || user?.role === 'team';

  return (
    <Container maxWidth="lg">
      <Breadcrumbs aria-label="breadcrumb" sx={{ my: 2 }}>
        <MuiLink component={Link} to="/" color="inherit">
          Home
        </MuiLink>
        <Typography color="text.primary">Invoices</Typography>
      </Breadcrumbs>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Invoice Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Create, manage, and track staff invoices. Archive old invoices to keep your workspace organized.
        </Typography>
      </Box>

      {/* Bulk Operations for Admins */}
      <Collapse in={isAdmin}>
        <InvoiceBulkOperations onRefresh={handleRefresh} />
      </Collapse>

      {/* Main Invoice List */}
      <InvoiceList key={refreshTrigger} />
    </Container>
  );
};

export default InvoiceListPage;